/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_BirdInputs */

const en_val_bird = /** @type {(inputs: Val_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bird`)
};

const es_val_bird = /** @type {(inputs: Val_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pájaro`)
};

const fr_val_bird = /** @type {(inputs: Val_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oiseau`)
};

const de_val_bird = /** @type {(inputs: Val_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vogel`)
};

const ja_val_bird = /** @type {(inputs: Val_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`鳥`)
};

const zh_val_bird = /** @type {(inputs: Val_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`鸟类`)
};

const ar_val_bird = /** @type {(inputs: Val_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`طائر`)
};

const id_val_bird = /** @type {(inputs: Val_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Burung`)
};

const it_val_bird = /** @type {(inputs: Val_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uccello`)
};

const ru_val_bird = /** @type {(inputs: Val_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Птица`)
};

const pt_val_bird = /** @type {(inputs: Val_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pássaro`)
};

const ko_val_bird = /** @type {(inputs: Val_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새`)
};

/**
* | output |
* | --- |
* | "Bird" |
*
* @param {Val_BirdInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_bird = /** @type {((inputs?: Val_BirdInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_BirdInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_bird(inputs)
	if (locale === "es") return es_val_bird(inputs)
	if (locale === "fr") return fr_val_bird(inputs)
	if (locale === "de") return de_val_bird(inputs)
	if (locale === "ja") return ja_val_bird(inputs)
	if (locale === "zh") return zh_val_bird(inputs)
	if (locale === "ar") return ar_val_bird(inputs)
	if (locale === "id") return id_val_bird(inputs)
	if (locale === "it") return it_val_bird(inputs)
	if (locale === "ru") return ru_val_bird(inputs)
	if (locale === "pt") return pt_val_bird(inputs)
	return ko_val_bird(inputs)
});